import type { OpencodeToolPart } from "schemas/generated/agentTools/opencode";

import { getToolPartOutputRecord } from "./bedrock-shared";

export function getMembershipsDetail({
  emptyLabel,
  toolPart,
}: {
  emptyLabel: string;
  includeRole?: boolean;
  toolPart: OpencodeToolPart;
}) {
  const outputRecord = getToolPartOutputRecord({ toolPart });
  const memberships = Array.isArray(outputRecord?.memberships)
    ? outputRecord.memberships
    : null;
  if (!memberships) {
    return null;
  }

  if (memberships.length === 0) {
    return emptyLabel;
  }

  return `including ${memberships.length === 1 ? "1 member" : `${memberships.length} members`}`;
}
